<template>
  <modal
    @before-close="modalClose"
    @before-open="modalOpen"
    :name="`gallery`"
    :adaptive="true"
    :clickToClose="false"
    :reset="true"
    :scrollable="true"
    :height="'auto'"
    :width="800"
  >
    <div class="images" ref="images">
      <h4>{{ "gallery" | setText("gallery") }}</h4>

      <div v-if="!base64.length" class="images-control">
        <button @click="$modal.hide('gallery')" class="btn btn-danger mr-3">
          {{ "сlose" | setText("Закрыть") }}
        </button>
        <button @click="$refs.uploadImage.click()" class="btn btn-success">
          <span class="ti-plus"></span>
          {{ "upload_another" | setText("Загрузить другое") }}
        </button>
      </div>

      <br />
      <br />

      <div v-if="base64 && base64.length">
        <h6>
          {{
            "will_be_upload_gallery"
              | setText(
                "Изображение-(я), которые будут загружены в вашу галлерею перед выбором"
              )
          }}
        </h6>
        <br />
        <div :class="`upload ${uploading === true ? 'loading' : ''}`">
          <ul v-if="base64 && base64.length" class="pimages mb-3">
            <li v-for="(file, key) in base64" :key="key">
              <img :src="file['content']" alt="" />
              <button class="remove" @click="removeItemBase64(key)">
                <span class="ti-close"></span>
              </button>
            </li>
          </ul>

          <button
            v-if="uploading === false"
            @click="uploadCancel"
            class="btn btn-sm btn-danger mr-2"
          >
            {{ "cancel" | setText("Отмена") }}
          </button>

          <button
            v-if="uploading === false"
            @click="addMedia"
            class="btn btn-sm btn-info mr-2"
          >
            <span class="ti-upload"></span>
            {{ "upload" | setText("Загрузить") }}
          </button>
        </div>
      </div>
      <input
        type="file"
        ref="uploadImage"
        @change="chooseImages"
        accept="image/*"
        :value="file_value"
        class="choose-file"
        v-bind:multiple="true"
      />
      <div v-if="(!base64 || !base64.length) && done">
        <h6>
          {{
            "choose_image"
              | setText(
                "Выберите и нажмите на изображение, которое хотите вставить"
              )
          }}
        </h6>

        <ul v-if="data.length" class="pimages">
          <template v-for="(item, key) in data">
            <li v-if="item && item.id" :key="item.id">
              <img @click="selectImage(item)" :src="item[url]" alt="" />
              <button class="remove" @click="removeItem(item, key)">
                <span class="ti-close"></span>
              </button>
              <button @click="selectImage(item)" class="select">выбрать</button>
            </li>
          </template>
        </ul>

        <h5 v-else>
          {{
            "you_have_no_upload_image"
              | setText("У вас не загружены изображения.")
          }}
          <span @click="$refs.uploadImage.click()" class="link">{{
            "upload_image" | setText("Загрузить изобржение")
          }}</span>
        </h5>
      </div>
    </div>
  </modal>
</template>

<script>
import draggable from "vuedraggable";
import { errorNotify } from "@/plugins/functions";

export default {
  created() {
    this.getMedia();
  },
  data: () => ({
    base64: [],
    data: [],
    file_value: "",
    uploading: false,
    done: false,
  }),
  components: {
    draggable,
  },
  props: {
    url: {
      default: "path_small",
    },
    value: {
      default: function () {
        return [];
      },
    },
    title: {
      default: function () {
        return "";
      },
    },
    link: {
      default: function () {
        return "business/media";
      },
    },
  },

  methods: {
    selectImage(item) {
      this.$emit("input", item.path);
      this.$modal.hide("gallery");
    },
    getMedia() {
      this.$loading(true);
      this.$http
        .get("business/media")
        .then((response) => {
          this.data = response.data.data;
          this.done = true;
        })
        .finally(() => {
          this.$loading(false);
        });
    },
    async addMedia() {
      this.$loading(true);
      const form = new FormData();
      for (let j = 0; j < this.base64.length; j++) {
        if (
          this.base64[j].file &&
          typeof this.base64[j].file.name === "string"
        ) {
          await form.append(`media[${j}]`, this.base64[j].file);
        }
      }
      return this.$http({
        url: "business/media",
        method: "POST",
        data: form,
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "application/json",
          "api-version": "1",
          platform: "web",
        },
      })
        .then((response) => {
          this.getMedia();
          this.base64 = [];
        })
        .catch((error) => {
          errorNotify(error, this.notify);
        })
        .finally(() => {});
    },
    modalClose() {},
    modalOpen() {},
    chooseImages() {
      try {
        let new_images = this.$refs.uploadImage.files;
        for (let i = 0; i < new_images.length; i++) {
          let file = new_images[i];
          if (!file.size || file.size > 1048576) {
            this.$notify({
              title: `${file.name}`,
              message: "MAX FILE SIZE 1 MB",
              icon: "ti-save",
              horizontalAlign: "right",
              verticalAlign: "top",
            });
            continue;
          }
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.addEventListener("load", () => {
            this.base64.push({
              file: file,
              content: reader.result,
            });
          });
        }
      } catch (error) {}
    },
    uploadCancel() {
      this.base64 = [];
      this.file_value = "";
    },
    removeItem(item, key) {
      this.$dialog
        .confirm(this.$store.state.text.sure_delete, {
          okText: this.$store.state.text.delete,
          cancelText: this.$store.state.text.cancel,
        })
        .then(() => {
          this.$loading(true);
          this.$http
            .post(`${this.link}/${item.id}`, { _method: "DELETE" })
            .then((response) => {
              this.data.splice(key, 1);
            })
            .catch((error) => {})
            .finally(() => {
              setTimeout(() => {
                this.$loading(false);
              }, 400);
            });
        })
        .catch(() => {});
    },
    removeItemBase64(key) {
      this.base64.splice(key, 1);
      this.$emit("input", this.base64);
    },
  },
  computed: {
    countNewImages: {
      get() {
        return this.base64.length;
      },
    },
    result_length: function () {
      return this.data.length;
    },
  },
  watch: {
    countNewImages(val) {
      if (val > 0) {
        this.$modal.show("upload");
      } else {
        this.uploading = false;
        this.$modal.hide("upload");
      }
    },
    result_length() {
      this.base64 = [];
    },
  },
};
</script>
<style lang="scss">
.images {
  margin-bottom: 30px;
  background: #fff;
  padding: 15px;
  border-radius: 10px;

  .choose-file {
    position: absolute;
    opacity: 0;
  }

  ul.pimages {
    display: flex;
    flex-wrap: wrap;
    margin-right: -10px;

    & > li {
      background: #fff;
      max-width: 50%;
      width: 140px;
      height: 140px;
      padding: 10px;
      margin-right: 10px;
      border: 1px solid #ebebeb;
      position: relative;
      margin-bottom: 10px;
      border-radius: 10px;
      overflow: hidden;
      text-align: center;

      &.noload {
        border-color: red;
        border-width: 3px;
      }

      & > img {
        width: 100%;
        height: 100%;
        position: absolute;
        max-width: 75%;
        max-height: 75%;
        -o-object-fit: contain;
        object-fit: contain;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }

      & > button.remove {
        border: none;
        box-shadow: none;
        position: absolute;
        right: 5px;
        top: 5px;
        background: #ebebeb;
        height: 20px;
        width: 20px;
        font-size: 10px;
        text-align: center;
        padding: 3px;
        border-radius: 3px;
      }

      & > button.select {
        border: none;
        box-shadow: none;
        position: absolute;
        bottom: 0;
        background: #ebebeb;
        height: 23px;
        font-size: 12px;
        left: 0;
        right: 0;
        top: auto;
        opacity: 0.8;
        text-align: center;
        width: 100%;
        border-radius: 0;
      }
    }
  }

  .loading {
    opacity: 0.3;
    pointer-events: none;
    cursor: progress;
  }
}
</style>
